import React from 'react';
import { useState, useEffect, Fragment } from "react";
import DataTable from 'react-data-table-component';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { PiUsersThreeDuotone } from "react-icons/pi";
import { PiUserBold } from "react-icons/pi";
import { FaDownload } from "react-icons/fa6";
import { PiPencilSimpleLine } from "react-icons/pi";
import { PiTrashDuotone } from "react-icons/pi";
import { PiTrashThin, PiNotePencilBold } from "react-icons/pi";
import { IoAddCircle, IoTrashBin } from "react-icons/io5";
import { FcSearch } from "react-icons/fc";
import InputGroup from 'react-bootstrap/InputGroup';
import UsecaseClientMap from './usecase-client-map';
import userDetailsJson from '../../../json-data/userdetails.json';
import UserCreation from './Modal-dialog/user-creation';
import BulkUserCreation from './Modal-dialog/bulk-user-creation';
import EditUserDetails from './Modal-dialog/edit-user-details';
import { TypeAnimation } from 'react-type-animation';
import { configData } from "../../../config/systemconfigurationconstants";
import UseLambdaInvocations from '../../../hooks/useLambdaInvocations';
import * as AWS from 'aws-sdk';
import lambdaConfig from '../../../hooks/lambdaConfig';
import { ToastContainer, toast } from "react-toastify";
import { CgClose } from "react-icons/cg";
import { useEncryption } from '../../../customHooks/useEncryption';
const UserDetails = () => {
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const [useCaseListForUserCreation, setUseCaseListForUserCreation] = useState([]);
    const [userRoleListForUserCreation, setUserRoleListForUserCreation] = useState([]);
    const [userProviderForUserCreation, setUserProviderForUserCreation] = useState([]);
    const [dotloader, setDotLoader] = useState(false);
    const [userList, setUserList] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    useEffect(() => {
        getUserDetails();
        getUserListForUpdate();

    }, [])
    const getUserDetails = async () => {
        setDotLoader(false);
        try {
            const parsedBody = await invokeLambda(configData.GET_USER_DETAILS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),

            });

            if (parsedBody.Status) {
                setUserDetails(parsedBody.UserInfo)
                setAllUserDetails(parsedBody.UserInfo)
                setUseCaseListForUserCreation(parsedBody.UseCaseClientInfo[0].UseCase)
                setUserRoleListForUserCreation(parsedBody.UserRoleInfo)
                setUserProviderForUserCreation(parsedBody.Prvdrslst)
                setTimeout(() => {
                    setDotLoader(true);
                }, 1000);
            } else {
                setDotLoader(false);
            }
        } catch (err) {
            // Handle error if needed
            setDotLoader(false);

        }
    }
    const getUserListForUpdate = async () => {
        try {
            const parsedBody = await invokeLambda(configData.GET_USERS_LIST, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),

            });

            if (parsedBody.Status) {
                setUserList(parsedBody.UsersList)
                // setUserDetails(parsedBody.UserInfo)
                // setUseCaseListForUserCreation(parsedBody.UseCaseClientInfo[0].UseCase)
                // setUserRoleListForUserCreation(parsedBody.UserRoleInfo)
                // setUserProviderForUserCreation(parsedBody.Prvdrslst)
                // setTimeout(() => {
                //     setDotLoader(true);
                // }, 1000);
            } else {
                // setDotLoader(false);
            }
        } catch (err) {
            // Handle error if needed
            // setDotLoader(false);

        }
    }
    // const userDetails = userDetailsJson.UserInfo;
    const [userDetails, setUserDetails] = useState([])
    const [allUserDetails, setAllUserDetails] = useState([]); // keep full copy
    const [key, setKey] = useState('userdetails');
    const [usercreation, setUserCreation] = useState(false);
    const [bulkusercreation, setBulkUserCreation] = useState(false);
    const [edituserdetails, setEditUserDetails] = useState(false);

    const showUserCreation = () => setUserCreation(true);
    const showBulkUserCreation = () => setBulkUserCreation(true);
    const showEditUserDetails = () => setEditUserDetails(true);
    const closeusercreation = () => setUserCreation(false);
    const closebulkusercreation = () => setBulkUserCreation(false);
    const closeedituserdetails = () => setEditUserDetails(false);

    const customTooltip = (text) => (
        <Tooltip id="tooltip">{text}</Tooltip>
    );

    const columns = [
        {
            name: 'First Name',
            selector: row => row.FirstName,
            sortable: true,
            sortFunction: (a, b) => a.FirstName.toLowerCase().localeCompare(b.FirstName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.FirstName)}
                >
                    <span className='text-truncate'>{row.FirstName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Last Name',
            selector: row => row.LastName,
            sortable: true,
            sortFunction: (a, b) => a.LastName.toLowerCase().localeCompare(b.LastName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.LastName)}
                >
                    <span className='text-truncate'>{row.LastName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Middle Name',
            selector: row => row.MiddleName,
            sortable: true,
            // sortFunction: (a, b) => a.MiddleName.toLowerCase().localeCompare(b.MiddleName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.MiddleName)}
                >
                    <span className='text-truncate'>{row.MiddleName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'User Name',
            selector: row => row.UserName,
            sortable: true,
            sortFunction: (a, b) => a.UserName.toLowerCase().localeCompare(b.UserName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.UserName)}
                >
                    <span className='text-truncate'>{row.UserName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Email ID',
            selector: row => row.EmailID,
            sortable: true,
            sortFunction: (a, b) => a.EmailID.toLowerCase().localeCompare(b.EmailID.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.EmailID)}
                >
                    <span className='text-truncate'>{row.EmailID}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Role',
            selector: row => row.RoleName,
            sortable: true,
            sortFunction: (a, b) => a.RoleName.toLowerCase().localeCompare(b.RoleName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.RoleName)}
                >
                    <span className='text-truncate'>{row.RoleName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Client',
            selector: row => row.ClientName,
            sortable: true,
            sortFunction: (a, b) => a.ClientName.toLowerCase().localeCompare(b.ClientName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.ClientName)}
                >
                    <span className='text-truncate'>{row.ClientName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Use Case',
            selector: row => row.UseCaseName,
            sortable: true,
            sortFunction: (a, b) => a.UseCaseName.toLowerCase().localeCompare(b.UseCaseName.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.UseCaseName)}
                >
                    <span className='text-truncate'>{row.UseCaseName}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Two Factor Enabled',
            selector: row => row.IsTwoFactorEnabled,
            sortable: true,
            // sortFunction: (a, b) => a.IsTwoFactorEnabled.toLowerCase().localeCompare(b.IsTwoFactorEnabled.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.IsTwoFactorEnabled ? 'Yes' : '')}
                >
                    <span className='text-truncate'>
                        {row.IsTwoFactorEnabled ? 'Yes' : ''}
                    </span>
                </OverlayTrigger>
            ),
        },

        {
            name: 'Provider',
            selector: row => row.Provider,
            sortable: true,
            // sortFunction: (a, b) => a.Provider.toLowerCase().localeCompare(b.Provider.toLowerCase()),
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(row.Provider)}
                >
                    <span className='text-truncate'>{row.Provider}</span>
                </OverlayTrigger>
            ),
        },
        {
            name: 'Action',
            cell: row => (
                <div className='d-flex justify-content-evenly w-100'>
                    {/* Edit Icon with Tooltip */}
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit User</Tooltip>}
                    >
                        <div onClick={() => getEditedUserDetails(row)} className='icon edit'>
                            <PiNotePencilBold />
                        </div>
                    </OverlayTrigger>

                    {/* Delete Icon with Tooltip and Popover (Cleanly Separated) */}
                    {hasRightsToCreateEditDeleteUsers() && (
                        <OverlayTrigger
                            trigger="click"
                            placement="left"
                            overlay={deletePopover}
                            rootClose
                            onToggle={(show) => {
                                if (show) setSelectedUser(row);
                            }}
                        >
                            <span>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltip-delete-${row.id}`}>
                                            Delete User
                                        </Tooltip>
                                    }
                                >
                                    <div className="icon delete">
                                        <IoTrashBin />
                                    </div>
                                </OverlayTrigger>
                            </span>
                        </OverlayTrigger>
                    )}
                    {!hasRightsToCreateEditDeleteUsers() && (
                        <div className="icon delete" onClick={notAuthorized}>
                            <IoTrashBin />
                        </div>
                    )}



                    {/* Lock/Unlock Switch with Popover and Tooltip */}
                    {hasRightsToCreateEditDeleteUsers() && (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id={`tooltip-lock-${row.id}`}>
                                    {row.IsAccountLockedOut ? "Unlock Account" : "Lock Account"}
                                </Tooltip>
                            }
                        >
                            <Button variant="link" size="sm">
                                <OverlayTrigger
                                    trigger="click"
                                    placement="left"
                                    overlay={switchPopover}
                                    rootClose
                                    onToggle={(show) => {
                                        if (show) setSelectedUser(row);
                                    }}
                                >
                                    <span>
                                        <Form.Check
                                            type="switch"
                                            aria-label="Toggle switch"
                                            checked={row.IsAccountLockedOut}
                                        />
                                    </span>
                                </OverlayTrigger>
                            </Button>
                        </OverlayTrigger>
                    )}
                    {!hasRightsToCreateEditDeleteUsers() && (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id={`tooltip-lock-${row.id}`}>
                                    {row.IsAccountLockedOut ? "Unlock Account" : "Lock Account"}
                                </Tooltip>
                            }
                        >
                            <Button variant="link" size="sm">
                                <span>
                                    <Form.Check
                                        disabled
                                        type="switch"
                                        aria-label="Toggle switch"
                                        checked={row.IsAccountLockedOut}
                                    />
                                </span>
                            </Button>
                        </OverlayTrigger>
                    )}

                </div>
            )
        }



    ];
    const deleteUserInAdmin = async () => {
        setDotLoader(false);
        let inputJson = {
            UserJSON: {
                Delete: [
                    {
                        DeleteUser: 1,
                    },
                ],
            },
            UserSecurityId: userList.find((el) => el.UserName == selectedUser?.UserName)
                .SecurityId,
        };
        try {
            const parsedBody = await invokeLambda(configData.EDIT_USER_DETAILS, {
                ...lambdaConfig,
                ...inputJson,
                SecurityToken: localStorage.getItem('SecurityToken'),
                // "LoanGuid": localStorage.getItem('loanGuid'),
            });
            // if (Array.isArray(parsedBody.Output.impdata)) {
            if (parsedBody.Status) {
                toast.success("User delete Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 1000);
                // getUserDetails();
                getUserDetails();
                setSearchTerm('');
                setUserDetails(allUserDetails);

            } else {
                toast.error("User delete Failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setDotLoader(false);
            }
        } catch (err) {
            // Handle error if needed
            setDotLoader(false);

        }
    }
    const deletePopover = (
        <Popover id="popover-delete-confirmation">
            <Popover.Header as="h3">Delete Account</Popover.Header>
            <Popover.Body>
                Do u want to Delete the User Account?
                <div className="mt-2 d-flex justify-content-end gap-2">
                    <Button variant="primary" size="sm" onClick={deleteUserInAdmin}><PiTrashThin className="shake-icon" style={{ fontSize: '16px' }} /> Delete</Button>
                </div>
            </Popover.Body>
        </Popover>
    );
    const lockOrUnlockUser = async () => {
        setDotLoader(false);
        let inputJson = {
            UserJSON: {
                LockUnlockUserAccount: [
                    {
                        lckunlckusrac: (selectedUser?.IsAccountLockedOut === false) ? 1 : 0,
                        // lckunlckusrac: 0,
                    },
                ],
            },
            UserSecurityId: userList.find((el) => el.UserName == selectedUser?.UserName)
                .SecurityId,
        };
        try {
            const parsedBody = await invokeLambda(configData.EDIT_USER_DETAILS, {
                ...lambdaConfig,
                ...inputJson,
                SecurityToken: localStorage.getItem('SecurityToken'),
                // "LoanGuid": localStorage.getItem('loanGuid'),
            });
            // if (Array.isArray(parsedBody.Output.impdata)) {
            if (parsedBody.Status) {
                const message = selectedUser?.IsAccountLockedOut === false ? "User locked successfully" : "User Unlocked successfully";
                toast.success(message, {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 1000);
                //getUserDetails();
                getUserDetails();
                setSearchTerm('');
                setUserDetails(allUserDetails);
            } else {
                toast.error("User locked Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setDotLoader(false);
            }
        } catch (err) {
            // Handle error if needed
            setDotLoader(false);

        }
    }
    const switchPopover = (
        <Popover id="popover-switch">
            {selectedUser?.IsAccountLockedOut === false ? <Popover.Header as="h3">Lock Account</Popover.Header> : <Popover.Header as="h3">UnLock Account</Popover.Header>}
            <Popover.Body>
                {selectedUser?.IsAccountLockedOut === false ? <span>Do u want to Lock the User Account?</span> : <span>Do u want to UnLock the User Account?</span>}
                <div className="mt-2 d-flex justify-content-end gap-2">


                    <Button variant="primary" size="sm" onClick={lockOrUnlockUser}>Confirm</Button>
                </div>
            </Popover.Body>
        </Popover>
    );

    const renderTabTitle = (tabKey, title) => {
        if (key === tabKey) {
            return (
                <span className="fixed-tab-title">
                    <TypeAnimation
                        sequence={[title]}
                        speed={40}
                        wrapper="span"
                        cursor={false}
                        repeat={0}
                        key={key}
                    />
                </span>
            );
        }
        return <span className="fixed-tab-title">{title}</span>;
    };

    const getEditedUserDetails = (value) => {
        if (hasRightsToCreateEditDeleteUsers()) {
            setSelectedUserData(value); // the user to edit
            setIsEditMode(true); // set edit mode
            setUserCreation(true);
            showUserCreation();
            console.log(value);
        } else {
            toast.warning("Not authorized to edit user", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    };
    const createUserInAdmin = () => {
        if (hasRightsToCreateEditDeleteUsers()) {
            setIsEditMode(false);
            setSelectedUserData(null);
            setUserCreation(true);
            showUserCreation();
        } else {
            toast.warning("Not authorized to create user", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    };
    const downloadBulkUserCreationTemplate = () => {
        AWS.config.credentials = new AWS.Credentials({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk'))
        });
        let getUseCaseName = localStorage.getItem('UseCaseShortName');
        let getClientName = localStorage.getItem('ClientShortName')
        let mergeUsecaseandClient = getClientName + '_' + getUseCaseName
        const params = {
            Bucket: configData.BUCKET_NAME,
            Key: mergeUsecaseandClient + '/' + 'Bulk_Users_Creation_Template.xlsx',
            Expires: 300 // The URL will now expire in 5 minutes (300 seconds)
        };
        let s3 = new AWS.S3();
        var url = s3.getSignedUrl('getObject', params);
        window.open(url, '_blank');
    }
    const screenWidth = window.innerWidth;
    let minHeight;

    if (screenWidth == 1920) {
        minHeight = '626px';
    } else if (screenWidth == 1680) {
        minHeight = '595px';
    } else if (screenWidth == 1600) {
        minHeight = '448px';
    } 
    // else if (screenWidth == 1280) {
    //     minHeight = '575px';
    // }
     else {
        minHeight = 'calc(100vh - 314px)';
    }
    const customStyles = {
        table: {
            style: {
                minHeight,
                backgroundColor: 'white',
                overflowY: 'auto',
            },
        },

    };
    const searchTable = () => {
        if (!searchTerm.trim()) {
            setUserDetails(allUserDetails); // reset to full list when search is cleared
            return;
        }

        const filteredData = allUserDetails.filter((row) =>
            Object.values(row)
                .filter((v) => v !== null && v !== undefined)
                .some((value) =>
                    value.toString().toLowerCase().includes(searchTerm.toLowerCase())
                )
        );

        setUserDetails(filteredData);
    };
    const hasRightsToCreateEditDeleteUsers = () => {
    if (rolesAndRights !== null) {
      let rightID = rolesAndRights.AllRights.find((el) => el.RightType.trim() == "CREATE_EDIT_DELETE_USERS")?.RightId;
      if(userRights.some(el => el.RightId == rightID)) {
        return userRights.find((el) => el.RightId == rightID)?.RightValue == 1 ? true : false;
      }
    }
  };
    const notAuthorized = () => {
        toast.warning("Not authorized to edit user", {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const hasRightsToUsecaseClientMap = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights.AllRights.find((el) => el.RightType.trim() == "USECASE_CLIENT_MAP")?.RightId;
            if (userRights.some(el => el.RightId == rightID)) {
                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }


    return (
        <Fragment>
            {dotloader ? (<Row>
                <Col sm={12}>
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        unmountOnExit

                    >
                        <Tab eventKey="userdetails" title={renderTabTitle('userdetails', 'User Details')}>
                            <Row>
                                <Col sm={2}>
                                    <InputGroup size="sm">
                                        <InputGroup.Text>
                                            <FcSearch className="search-icon-animated" />
                                        </InputGroup.Text>
                                        <Form.Control size="sm" type="text" placeholder="Search" value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            onKeyUp={searchTable} />
                                        {searchTerm && (
                                            <InputGroup.Text
                                                style={{ cursor: 'pointer', color: 'darkblue' }}
                                                onClick={() => {
                                                    setSearchTerm('');
                                                    setUserDetails(allUserDetails); // Reset the filtered data
                                                }}
                                            >
                                                <CgClose />
                                            </InputGroup.Text>
                                        )}
                                    </InputGroup>
                                </Col>
                                <Col sm={10} style={{ display: 'flex', flexDirection: 'row-reverse', gap: '5px', marginBottom: '5px' }}>
                                    <Button variant="outline-primary" size='sm' onClick={createUserInAdmin}><PiUserBold style={{ fontSize: '14px' }} />
                                        Create User</Button>
                                    <Button variant="outline-primary" size='sm' onClick={showBulkUserCreation}><PiUsersThreeDuotone style={{ fontSize: '18px' }} /> Create Bulk Users</Button>
                                    <Button variant="outline-success" size='sm' onClick={downloadBulkUserCreationTemplate} ><FaDownload className='bounce-icon' />
                                        Download Template</Button>
                                </Col>
                            </Row>
                            <Row>


                                <Col sm={12} className='user-dtl'>
                                    <DataTable
                                        columns={columns}
                                        data={userDetails}
                                        dense
                                        pagination
                                        customStyles={customStyles}
                                    />
                                </Col>
                            </Row>
                        </Tab>
                        {hasRightsToUsecaseClientMap() &&(<Tab eventKey="usecaseclientmap" title={renderTabTitle('usecaseclientmap', 'Usecase Client Map')} className='usecaseclient-tab'>
                            <UsecaseClientMap userDetails={userDetails} userList={userList} usecaseList={useCaseListForUserCreation} userRole={userRoleListForUserCreation} />
                        </Tab>)}

                    </Tabs>
                </Col>
            </Row>
            ) : (
                <div style={{ marginTop: "20%", marginBottom: "20%" }} className="d-flex justify-content-center">
                    <div className="loader"></div>
                </div>
            )}
            <UserCreation show={usercreation} handleClose={closeusercreation} usecaseList={useCaseListForUserCreation} userRole={userRoleListForUserCreation} userProvider={userProviderForUserCreation} getUserDetails={getUserDetails} mode={isEditMode ? "edit" : "create"}
                userData={isEditMode ? selectedUserData : null} userList={userList} getUserListForUpdate={getUserListForUpdate} setSearchTerm={setSearchTerm}
            />
            <BulkUserCreation show={bulkusercreation} handleClose={closebulkusercreation} usecaseList={useCaseListForUserCreation} userRole={userRoleListForUserCreation} getUserDetails={getUserDetails} />
            {/* <EditUserDetails show={edituserdetails} handleClose={closeedituserdetails} /> */}
        </Fragment>
    );
};

export default UserDetails;